module.exports = __webpack_public_path__ + "static/media/food-6.8b32a599.jpg";